export const SaveSearchBegin = 'SaveSearchBegin'
export const SaveSearchFail = 'SaveSearchFail'
export const SaveSearchModalCancel = 'SaveSearchModalCancel'
export const SaveSearchModalLoad = 'SaveSearchModalLoad'
export const SaveSearchSuccess = 'SaveSearchSuccess'
export const SaveSearchDeleteSuccess = 'SaveSearchDeleteSuccess'
